import React from 'react'
import Btn from 'components/Btn'
import { UilPlus } from '@iconscout/react-unicons'

export default function QuickLinkCard({ icon: Icon, title, description, btnText, onClick, disabled }) {
  return (
    <div className="flex-1 min-w-0 flex items-start gap-2 py-4 md:py-0 md:px-4 md:first:pl-0 md:last:pr-0">
      <Icon className="text-primary shrink-0" size={24} />

      <div className="flex-1 min-w-0">
        <h4 className="text-base font-semibold text-dark-blue">{title}</h4>
        <p className="text-xs text-secondary mt-1 mb-3">{description}</p>

        <Btn
          content={() => (
            <span className="flex items-center justify-center whitespace-nowrap">
              <UilPlus size={16} className="mr-1.5 shrink-0" /> {btnText}
            </span>
          )}
          className="h-9 px-4 rounded-full border border-border-lines text-primary font-semibold normal-case text-sm"
          click={onClick}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
